
import { createClient, processLock } from '@supabase/supabase-js'
import 'react-native-url-polyfill/auto'
import { secureStorage } from './secureStorage'

const FETCH_TIMEOUT_MS = 15000;

const fetchWithTimeout: typeof fetch = (input, init) => {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), FETCH_TIMEOUT_MS);

  return fetch(input, {
    ...init,
    signal: controller.signal,
  }).finally(() => clearTimeout(timeout));
};

export const supabase = createClient(
  process.env.EXPO_PUBLIC_SUPABASE_URL!,
  process.env.EXPO_PUBLIC_SUPABASE_KEY!,
  {
    auth: {
      // SecureStore-backed (iOS Keychain / Android EncryptedSharedPreferences)
      // with transparent one-time migration from AsyncStorage for existing sessions.
      storage: secureStorage,
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: false,
      // PKCE : les liens email (recovery…) délivrent un code à usage unique
      // lié à un verifier stocké sur CET appareil — inexploitable par une app
      // tierce qui intercepterait le scheme repas:// sur Android. Le code est
      // échangé via createSessionFromUrl (utils/authSession.ts).
      flowType: 'pkce',
      lock: processLock,
    },
    global: {
      fetch: fetchWithTimeout,
    },
  })
        